import { reactive } from 'vue'
import { useAuthStore } from './authStore'
import { markTourSeen } from './auth'
import { userHasPageAccess } from '@/constants/accessControl'

// Pasos de la guía. Cada paso de sección apunta al enlace del menú (data-tour="nav-<pageKey>")
// y solo aparece si el usuario tiene acceso a esa sección.
const SECTION_STEPS = [
  {
    pageKey: 'dashboard', icon: 'mdi-view-dashboard-outline', title: 'Inicio',
    text: 'Tu panel de control: ocupación del parque, ingresos del mes y las alertas que necesitan tu atención. Es el mejor lugar para empezar cada día.',
  },
  {
    pageKey: 'contratos', icon: 'mdi-file-document-edit-outline', title: 'Contratos',
    text: 'Tus naves, inquilinos y contratos: altas, vencimientos próximos, renovaciones y el historial de cada contrato. Si tienes muchos, puedes importarlos todos desde un Excel.',
  },
  {
    pageKey: 'mantenimiento', icon: 'mdi-wrench-outline', title: 'Mantenimiento',
    text: 'Solicitudes y tickets de mantenimiento: asígnalos a un técnico, da seguimiento a costos y programa el mantenimiento preventivo.',
  },
  {
    pageKey: 'servicios', icon: 'mdi-fire-hydrant', title: 'Servicios',
    text: 'Agua, luz y otros servicios del parque: captura las lecturas y reparte el costo entre tus inquilinos.',
  },
  {
    pageKey: 'cobranza', icon: 'mdi-cash-multiple', title: 'Cobranza',
    text: 'Todo lo que te deben: cargos del mes, cartera vencida, registro de pagos, recordatorios y estados de cuenta para tus inquilinos.',
  },
  {
    pageKey: 'finanzas', icon: 'mdi-wallet-outline', title: 'Finanzas',
    text: 'Ingresos contra gastos del parque, su evolución en el tiempo y reportes listos para tu contabilidad.',
  },
  {
    pageKey: 'configuracion', icon: 'mdi-cog-outline', title: 'Configuración',
    text: 'Datos del parque, reglas de cobranza, usuarios y permisos, y notificaciones. Si eres administrador, aquí también puedes exportar tus datos a Excel.',
  },
]

export const tour = reactive({ active: false, index: 0, steps: [] })

function buildSteps(user, withWelcome) {
  const steps = []
  if (withWelcome) steps.push({ kind: 'welcome' })
  for (const s of SECTION_STEPS) {
    if (userHasPageAccess(user, s.pageKey)) steps.push({ kind: 'section', ...s, target: `[data-tour="nav-${s.pageKey}"]` })
  }
  steps.push({ kind: 'end' })
  return steps
}

// withWelcome: la primera vez se ofrece con una bienvenida; al repetirla se va directo a las secciones.
export function startTour({ withWelcome = false } = {}) {
  const { state } = useAuthStore()
  if (!state.user || tour.active) return
  tour.steps = buildSteps(state.user, withWelcome)
  tour.index = 0
  tour.active = true
}

export const nextStep = () => {
  if (tour.index < tour.steps.length - 1) tour.index += 1
  else finishTour()
}
export const prevStep = () => {
  if (tour.index > 0) tour.index -= 1
}

// Terminar u omitir cuenta igual: la guía no vuelve a salir sola.
export function finishTour() {
  const { state } = useAuthStore()
  tour.active = false
  if (state.user?.tour?.pending) {
    state.user.tour.pending = false
    void markTourSeen()
  }
}